import { GraphQLClient } from 'graphql-request'

import { AuthRepository } from 'src/repositories'
import { CommonContentPageTranslator } from 'src/translators'
import { CommonContentPageEntity } from 'src/types'
import { getSdk } from 'src/types/generated-request'

export const useGetPromiseCommonPage = () => {
  const loadCommonPage = async (pageId: number): Promise<CommonContentPageEntity> => {
    const accessToken = AuthRepository.loadAccessToken()
    if (!accessToken) {
      throw new Error('accessToken is not found')
    }

    const response = await getSdk(
      new GraphQLClient(process.env.GraphQLUrl ?? '', {
        headers: { 'bearer-token': accessToken },
      })
    ).getCommonPage({ id: pageId })
    return CommonContentPageTranslator.toEntity(response.commonPage)
  }

  return {
    loadCommonPage,
  }
}
